import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Download a PDF from a backend endpoint (auth cookies preserved via axios).
 */
export async function downloadPdf(path, filename) {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success(`Downloaded ${filename}`);
  } catch (err) {
    toast.error(err.response?.status === 404 ? "Invoice not found"
      : err.response?.status === 403 ? "Admin access required" : "Download failed");
  }
}

/**
 * Email a PDF via the backend (mocked Resend → email_log).
 */
export async function emailPdf(path, body = {}) {
  try {
    const { data } = await api.post(path, body);
    toast.success(`Emailed to ${data.to}`);
    return data;
  } catch (err) {
    toast.error(err.response?.data?.detail || "Email failed");
    throw err;
  }
}
